import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PurchaseRequisitionHistoryEntry } from '../../../../purchase-requisition/types/PurchaseRequisitionHistoryEntry';
import { UntypedFormControl } from '@angular/forms';
import { Demand } from '../../../types/Demand';
import { AbstractComment } from '@lib/comment';
import dayjs, { Dayjs } from 'dayjs';

@Component({
    selector: 'demand-actitvity',
    templateUrl: './demand-actitvity.component.html',
    styleUrls: ['./demand-actitvity.component.scss'],
    standalone: false
})
export class DemandActitvityComponent implements OnInit {
    @Input() history!: PurchaseRequisitionHistoryEntry[];
    @Input() demand!: Demand;
    @Output() commentAdded: EventEmitter<void> = new EventEmitter<void>();

    public commentControl: UntypedFormControl = new UntypedFormControl('');

    private saving = false;

    public allEntries?: AbstractComment[];

    public async saveComment(): Promise<void> {
        if (this.commentControl.value && !this.saving) {
            this.saving = true;
            this.demand.addComment(this.commentControl.value.trim()).then(
                () => {
                    this.saving = false;
                    this.commentAdded.emit();
                    this.commentControl.setValue('');
                    this.fetchComments();
                },
                () => (this.saving = false),
            );
        }
    }

    public fetchComments(): void {
        this.demand.getAllComments().then((comments) => {
            const allEntries: AbstractComment[] = [...this.history, ...comments];
            allEntries.sort((a, b) => {
                const dateA: Dayjs = dayjs(a.timestamp);
                const dateB: Dayjs = dayjs(b.timestamp);
                if (dateA.isBefore(dateB)) {
                    return -1;
                }
                if (dateA.isAfter(dateB)) {
                    return 1;
                }
                return 0;
            });
            this.allEntries = allEntries;
        });
    }

    ngOnInit(): void {
        this.fetchComments();
    }
}
